import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, SirenActionMixin, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

import './device-list-item';
import '../device-list';
import '../../common/bn-loading';

class DeviceListByFlagView extends SirenActionMixin(LitEntity) {
  static get properties() {
    return {
      flagname: { type: String },
      renderItem: { type: Function },
      listHref: { type: String, attribute: false },
      listSnoozedHref: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
        position: relative;
      }
      h3 {
        margin: 1em 0 0 .5em;
      }
      p {
        margin: .75em .5em;
        color: var(--gray-80);
      }
    `];
  }

  render() {
    return html`
      <device-list
        .href="${this.listHref}"
        @select="${this._onSelect}"
        @update="${this._onListUpdate}"
        .renderItem=${this.renderItem}
      ></device-list>
      ${renderIf(this.listSnoozedHref, html`
        <h3>Snoozed</h3>
        <device-list
          flagname="${this.flagname}"
          .href="${this.listSnoozedHref}"
          @select="${this._onSelect}"
          @update="${this._onListUpdate}"
          .renderItem=${this.renderItem}
        >
          <p slot="no-devices">No snoozed devices</p>
        </device-list>
      `)}
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this._pullListHrefs();
  }

  updated() {
    this._pullListHrefs();
  }

  _pullListHrefs() {
    if (!this.entity) {
      return;
    }

    const action = this.entity.getActionByName('filter-by-flag');
    const fields = this.getActionFields(action);
    fields.set('flag', this.flagname);
    fields.set('flagVisibility', 'visible');
    fields.set('limit', 20);
    this.listHref = this.parseAction(action, fields).url.href;

    fields.set('flag', this.flagname);
    fields.set('flagVisibility', 'snooze');
    fields.set('limit', 20);
    this.listSnoozedHref = this.parseAction(action, fields).url.href;
  }

  _onListUpdate(e) {
    const { entity } = e.detail;
    if (!entity || !entity.class.includes('device-flag') || entity.properties.name !== this.flagname) {
      return;
    }

    entityStore.fetchWait(this.listHref);
    entityStore.fetchWait(this.listSnoozedHref);
  }
}

window.customElements.define('device-list-by-flag-view', DeviceListByFlagView);
